import React from "react";
import moment from "moment";
import { crossSellingOrderAnalysis } from "../../../Action/courseAction";
import { getuserDetailsByStatus } from "../../../Action/adminPanelAction";
import { OrderDayPage, countOf, dayOf, fetchUsers, pctOf } from "../../Common/orderAnalysisCommon";

const ORDER_USERS = ["firstName", "lastName", "mobileNo", "orderNo", "orderDate", "couponName", "whatsapp"];

// Sent / Delivered / Read / Failed open the users from the server (same request as before)
const byStatus = (status) => (row, _filters, dispatch) =>
  fetchUsers(dispatch, getuserDetailsByStatus, { startDate: dayOf(row?.orderDate), endDate: dayOf(row?.orderDate), status, type: "crossSellingMessage" });

const CrossSellingAnalysis = () => (
  <OrderDayPage
    pageTitle="Cross Selling Analysis"
    tableId="cross-selling-analysis"
    fetchAction={crossSellingOrderAnalysis} // same request as before
    parse={(res) => ({ rows: res?.data?.result, summary: res?.data?.totalSummary })}
    dateKey="orderDate"
    defaultFilters={{ startDate: moment.utc().startOf("month").format("YYYY-MM-DD") }} // month to date, as before
    columns={[
      { key: "totalNewOrders", header: "New Orders Details", kind: "list", listTitle: "Total New Orders", userColumns: ORDER_USERS },
      { key: "totalDayConversion", header: "Day Conversion (%)", kind: "pct" },
      { key: "totalCrossSellingOrdersDetails", header: "Cross Selling Order Details", kind: "list", listTitle: "Total CrossSelling Orders Details", userColumns: ORDER_USERS, minWidth: 140 },
      { key: "totalOrders", header: "Total Orders", kind: "count" },
      { key: "uniqueUsersDetails", header: "Unique Users Details", kind: "list", listTitle: "Unique Users Details", userColumns: ["firstName", "lastName", "mobileNo", "whatsapp"] },
      { key: "totalMessageSent", header: "Total Message Sent", kind: "count", fetchList: byStatus("SENT"), listTitle: "Message Sent", userColumns: ORDER_USERS },
      { key: "totalMessageDelivered", header: "Total Message Delivered", kind: "count", fetchList: byStatus("DELIVERED"), listTitle: "Message Delivered", userColumns: ORDER_USERS },
      { key: "totalMessageRead", header: "Total Message Read", kind: "count", fetchList: byStatus("READ"), listTitle: "Message Read", userColumns: ORDER_USERS },
      { key: "totalMessageFailed", header: "Total Message Failed", kind: "count", fetchList: byStatus("FAILED"), listTitle: "Message Failed", userColumns: ORDER_USERS },
      { key: "crossSellingRation", header: "Cross Selling Ratio (%)", kind: "pct", total: (_, s) => s?.totalCrossSellingRatio },
    ]}
    summaryGroups={(s) => [
      {
        title: "Total",
        tone: "primary",
        metrics: [
          { label: "Orders", value: countOf(s.totalOrders) },
          { label: "Unique Users", value: countOf(s.totalUniqueUsers) },
          { label: "Day Conversion", value: pctOf(s.totalDayConversion) },
        ],
      },
      {
        title: "Cross Selling",
        tone: "pink",
        metrics: [
          { label: "New Orders", value: countOf(s.totalNewOrders) },
          { label: "Cross Selling Orders", value: countOf(s.totalCrossSellingOrders) },
          { label: "Cross Selling Ratio", value: pctOf(s.totalCrossSellingRatio) },
        ],
      },
    ]}
    userColumns={ORDER_USERS}
  />
);

export default CrossSellingAnalysis;
